// src/components/ContactCTA.jsx
import React from "react";
import { useTranslation, Trans } from "react-i18next";
import LocalizedLink from "./LocalizedLink"; // ⬅️ use your localized link

export default function ContactCTA() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-16 bg-indigo-600 text-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold">{t("contact_cta.heading")}</h2>
            <p className="mt-2 text-indigo-100">{t("contact_cta.subheading")}</p>
          </div>

          <div className="bg-white/10 backdrop-blur rounded-2xl p-6 space-y-4">
            <LocalizedLink
              to="/contact" // LocalizedLink will prefix with /:lng for you
              className="block w-full text-center rounded-xl bg-white text-indigo-700 font-medium px-4 py-3 hover:bg-indigo-50"
            >
              {t("contact_cta.open_full_form", "Start your project")}
            </LocalizedLink>
          </div>
        </div>
      </div>
    </section>
  );
}
